const mouseMoveHandlers = [];
let mouseMoveStarted = false;

export default function useMouseEvents () {
    const invokeHandlers = (event) => {
        mouseMoveHandlers.forEach((handler) => handler(event));
    };

    const startMouseMove = () => {
        if (mouseMoveStarted) return;

        window.addEventListener('mousemove', invokeHandlers);
        mouseMoveStarted = true;
    };

    const stopMouseMove = () => {
        if (!mouseMoveStarted) return;

        window.removeEventListener('mousemove', invokeHandlers);
        mouseMoveStarted = false;
    };

    const addMouseMoveHandler = (handler) => {
        mouseMoveHandlers.push(handler);
    };

    const removeMouseMoveHandler = (handler) => {
        const index = mouseMoveHandlers.indexOf(handler);
        if (index >= 0) {
            mouseMoveHandlers.splice(index, 1);
        }
    };

    return {
        startMouseMove,
        stopMouseMove,
        addMouseMoveHandler,
        removeMouseMoveHandler,
    };
}
